export const SECURITY_SYSTEMS = {
    LGIP: 1,
    DBF: 2,
    Portfolio_Management: 3,
    Debt_Management: 4,
    Banking: 5,
    Workers_Comp: 6
} as const;